"use client";

import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Hero() {
  const {
    ref: heroRef,
    isVisible: heroVisible
  } = useRevealOnScroll<HTMLDivElement>({
    once: true,
    threshold: 0.1
  });
  return <section ref={heroRef} className="relative flex min-h-[85vh] w-full items-center justify-center overflow-hidden bg-cover bg-center bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1522495/img/lagos_skyline_dusk.png)]">
      {}
      <div className="absolute inset-0 bg-primary/60 backdrop-blur-sm" />

      {}
      <div className={`relative z-10 mx-4 max-w-3xl rounded-xl bg-background/80 px-8 py-12 text-center shadow-strong backdrop-blur-md transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] sm:px-12 sm:py-16 ${heroVisible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"}`} style={{
      transitionDelay: heroVisible ? "0ms" : "0ms"
    }}>
        {}
        <h1 className="mb-4 font-display text-4xl font-bold leading-tight text-foreground sm:text-5xl lg:text-6xl">
          Your Unfair Advantage in Nigerian Real Estate
        </h1>

        {}
        <p className="mb-8 text-lg text-muted-foreground sm:text-xl">
          Discover how Nethill Limited blends real estate intelligence with cutting-edge digital visibility strategies to deliver unmatched results.
        </p>

        {}
        <Link to="/ContactPage">
          <Button className="inline-flex items-center justify-center rounded-md bg-secondary px-6 py-3 font-semibold text-foreground-secondary shadow-medium transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)] hover:-translate-y-0.5 hover:bg-secondary-hover hover:shadow-strong focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring/40 active:translate-y-0 active:bg-secondary-active">
            Get Started Today
          </Button>
        </Link>
      </div>
    </section>;
}